import {
  LoadableUserSettingsNav,
  userSettingsNotificationsCommunitiesPageRoute,
  userSettingsNotificationsPageRoute,
  userSettingsPageRoute,
} from '@ms/yammer-user-settings-page';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { DefaultLeftNav } from './DefaultLeftNav';

export const AppLeftNav: React.FC = () => (
  <Switch>
    <Route
      exact={true}
      strict={true}
      path={[userSettingsNotificationsCommunitiesPageRoute, userSettingsNotificationsPageRoute, userSettingsPageRoute]}
    >
      <LoadableUserSettingsNav withAppName={true} />
    </Route>
    <Route>
      <DefaultLeftNav />
    </Route>
  </Switch>
);
